'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./Cloud.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIGHTER_CLOUD_PATH = 'M150.3,82.8c-7.2,0-13.9-3-18.1-7.9c-6.9,5.1-15.6,7.9-24.7,7.9c-10.4,0-20.3-3.7-27.4-10.2\nc-3.9,6.2-11.5,10.2-19.8,10.2c-6.6,0-12.8-2.5-17.1-6.8c-4,1.5-8.2,2.3-12.6,2.3C13.8,78.2,0,66.4,0,51.9s13.8-26.3,30.7-26.3\nc5.9,0,11.6,1.4,16.5,4.1C48.6,12.9,64.8,0,84.7,0c13.5,0,25.9,6.1,32.6,16.1c5.9-3.6,12.9-5.5,20.2-5.5c17.9,0,33,11.6,35,26.7\nc4.2-2.5,9.2-3.7,14.3-3.7c14.2,0,25.7,9.9,25.7,22.1S201,77.8,186.8,77.8c-6.1,0-12-1.9-16.7-5.3\nC166.3,78.8,158.7,82.8,150.3,82.8z M132.4,72.4c0,0,0.1,0,0.1,0c0.3,0,0.5,0.2,0.7,0.4c3.8,5,10.2,7.9,17.2,7.9\nc8,0,15.3-4,18.6-10.2c0.1-0.3,0.4-0.5,0.7-0.5c0.3-0.1,0.6,0,0.8,0.2c4.4,3.6,10.2,5.5,16.3,5.5c13.1,0,23.7-9,23.7-20.1\ns-10.7-20.1-23.7-20.1c-5.3,0-10.4,1.5-14.6,4.3c-0.3,0.2-0.7,0.2-1,0.1c-0.3-0.2-0.5-0.5-0.6-0.8c-1.1-14.8-15.6-26.4-33.2-26.4\nc-7.3,0-14.2,2-20,5.7c-0.2,0.1-0.5,0.2-0.8,0.1c-0.3-0.1-0.5-0.2-0.6-0.4C109.9,8.1,97.9,2,84.7,2C65.5,2,49.5,15.2,49.1,31.5\nc0,0.4-0.2,0.7-0.5,0.9c-0.3,0.2-0.7,0.2-1,0c-4.9-3-10.8-4.7-16.9-4.7C14.9,27.6,2,38.5,2,51.9s12.9,24.3,28.7,24.3\nc4.4,0,8.5-0.8,12.4-2.4c0.4-0.2,0.8-0.1,1.1,0.2c3.9,4.2,9.8,6.7,16.1,6.7c8,0,15.3-4,18.6-10.2c0.1-0.3,0.4-0.5,0.7-0.5\nc0.3,0,0.6,0.1,0.9,0.3c6.8,6.7,16.6,10.5,26.9,10.5c9,0,17.6-2.9,24.3-8.1C131.9,72.5,132.1,72.4,132.4,72.4z';

var CLOUD_PATH = 'M191,107.7c-9,0-17.4-3.5-23.1-9.4c-8.7,6.1-19.6,9.4-30.9,9.4c-12.8,0-25-4.3-34.2-11.9\nc-5.5,7.4-14.9,11.9-25.2,11.9c-8.4,0-16.3-3-22-8.3c-4.9,1.7-10,2.6-15.4,2.6C18.1,102,0,86.3,0,67.1c0-19.2,18.1-34.8,40.3-34.8\nc6.8,0,13.4,1.5,19.3,4.3C62.9,15.7,83.3,0,108.4,0c16.9,0,32.6,7.5,41.6,19.7c7.4-4.1,16-6.3,24.9-6.3c22.5,0,41.5,14,45.3,32.7\nc5.1-2.5,10.8-3.8,16.7-3.8c18.8,0,34.1,13.3,34.1,29.5s-15.3,29.5-34.1,29.5c-7.5,0-14.6-2.1-20.5-5.9\nC211,103,201.3,107.7,191,107.7z M168.4,91.2c0.1,0,0.2,0,0.4,0c0.8,0.1,1.5,0.5,2,1.2c4.4,5.8,12,9.3,20.2,9.3\nc9.5,0,18.1-4.7,21.9-11.9c0.4-0.8,1.2-1.4,2-1.5c0.9-0.2,1.8,0,2.5,0.6c5.3,4.3,12.2,6.6,19.5,6.6c15.5,0,28.1-10.6,28.1-23.5\ns-12.6-23.5-28.1-23.5c-6.3,0-12.4,1.8-17.4,5.1c-0.9,0.6-2,0.7-3,0.2c-1-0.5-1.6-1.4-1.7-2.5c-1.3-17.8-18.8-31.7-40-31.7\nc-8.8,0-17.2,2.4-24.2,6.9c-0.7,0.4-1.5,0.6-2.3,0.4c-0.8-0.2-1.5-0.7-1.9-1.3C139,13.4,124.4,6,108.4,6\nC85.2,6,65.8,21.9,65.2,41.4c0,1.1-0.6,2-1.6,2.6c-0.9,0.5-2.1,0.5-3-0.1c-5.9-3.7-13-5.6-20.3-5.6C21.4,38.3,6,51.2,6,67.1\nC6,83,21.4,96,40.3,96c5.3,0,10.3-1,15-2.9c1.2-0.5,2.5-0.2,3.3,0.7c4.6,5,11.5,7.9,19,7.9c9.5,0,18.1-4.7,21.9-12\nc0.4-0.8,1.3-1.4,2.2-1.6c0.9-0.1,1.9,0.2,2.6,0.8c8.2,8.1,20.1,12.7,32.7,12.7c11,0,21.4-3.5,29.5-9.8\nC167,91.4,167.7,91.2,168.4,91.2z';

var Cloud = function Cloud(_ref) {
    var lighter = _ref.lighter,
        className = _ref.className;
    return _react2.default.createElement(
        'svg',
        { className: (0, _classnames2.default)("cloud-comp", className, { lighter: lighter }),
            x: '0px',
            y: '0px',
            viewBox: lighter ? '0 0 212.6 82.8' : '0 0 271 107.7' },
        _react2.default.createElement('path', { className: 'cloud-path',
            d: lighter ? LIGHTER_CLOUD_PATH : CLOUD_PATH
        })
    );
};
Cloud.propTypes = {
    lighter: _propTypes2.default.bool,
    className: _propTypes2.default.string
};
Cloud.defaultProps = {
    lighter: false
};
exports.default = Cloud;
//# sourceMappingURL=Cloud.js.map